import React, {Component} from 'react';
import { withRouter } from "react-router-dom";






class ClaimsDoc extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Mobile: Setup &amp; Basics </h2>

                 <p className='text-primary'>
                    Learn to install, configure and use the most popular features in the BOUNTE mobile app. <br/>  Learn to add items to the lost and found. In addition, learn how to use the search feature to locate items quickly.  Edit items and update  Learn how to add Quick claims 

               
                </p>
               
                <br/>
               

                <h6> Using the Claims Screen </h6>
                <p className='text-primary'>

                    <iframe src="https://player.vimeo.com/video/490774241" width="640" height="360" title="video1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>

                 </p>
              
                <br/>
              
               
            </div>
        )
       


    }

}
export default withRouter(ClaimsDoc);
